export const APP_NAME = "Frameriver"

export const APP_COMPANY_SLUG = "default"

export function isAppCompany(company?: { slug?: string | null } | null) {
  return company?.slug === APP_COMPANY_SLUG
}

export function displayAppName(company?: { slug?: string | null; name?: string } | null) {
  if (isAppCompany(company)) return APP_NAME
  return company?.name ?? APP_NAME
}
